import { useCallback, useEffect, useMemo, useState } from 'react'
import { buildCategoryOptions, deriveCategoryKeyFromItem } from '../lib/categoryUtils.js'

export function useCategoryFilter(results) {
    const [activeCategoryKeys, setActiveCategoryKeys] = useState([])

    const categoryOptions = useMemo(() => buildCategoryOptions(results), [results])

    useEffect(() => {
        setActiveCategoryKeys(prev => {
            if (prev.length === 0) {
                return prev
            }
            const available = new Set(categoryOptions.map(option => option.key))
            const next = prev.filter(key => available.has(key))
            if (next.length === prev.length) {
                return prev
            }
            return next
        })
    }, [categoryOptions])

    const filteredResults = useMemo(() => {
        if (activeCategoryKeys.length === 0) {
            return results
        }
        const activeSet = new Set(activeCategoryKeys)
        return results.filter(item => activeSet.has(deriveCategoryKeyFromItem(item)))
    }, [results, activeCategoryKeys])

    const toggleCategory = useCallback(key => {
        if (!key) {
            return
        }
        setActiveCategoryKeys(prev => {
            const isActive = prev.includes(key)
            if (isActive) {
                return prev.filter(entry => entry !== key)
            }
            return [...prev, key]
        })
    }, [])

    const clearCategories = useCallback(() => {
        setActiveCategoryKeys(prev => (prev.length === 0 ? prev : []))
    }, [])

    return {
        categoryOptions,
        activeCategoryKeys,
        filteredResults,
        toggleCategory,
        clearCategories,
    }
}
